import { render, staticRenderFns } from "./edit-tag-search.vue?vue&type=template&id=56d0804e"
import script from "./edit-tag-search.vue?vue&type=script&lang=js"
export * from "./edit-tag-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports